import { toast } from 'components/core/Toast';
import { i18n } from 'services/translate';
import { logError } from 'utils/logError';
import checkEnvironment from './checkEnvironment';

export function handleCommunicationErrors(error) {
  const graphQLErrors = error?.graphQLErrors;
  if (!error || !Array.isArray(graphQLErrors) || graphQLErrors.length === 0) return;

  logError({ communicationError: error });
  const errorCode = graphQLErrors[0]?.extensions?.code;
  const exception = graphQLErrors[0]?.extensions?.exception;

  if (exception?.status === 409) {
    return;
  }

  switch (errorCode) {
    case 'FORBIDDEN':
      toast.info(i18n.t('feedback.forbidden'), { toastId: 'forbidden' });
      break;
    case 'BAD_USER_INPUT':
      toast.error(i18n.t('feedback.badUserInput'), { toastId: 'badUserInput' });
      break;
    case 'INTERNAL_SERVER_ERROR':
      toast.error(i18n.t('feedback.internalServerError'), { toastId: 'internalServerError' });
      break;
    default:
      toast.error(i18n.t('feedback.serverErrorTryAgain'), { toastId: 'communicationError' });
      break;
  }

  if (checkEnvironment().isProd) return;

  graphQLErrors.forEach(({ message }) => {
    toast.error(`Dev: ${message}`, { autoClose: false, toastId: message });
  });
}
